import { Spinner, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { useHistory, Route } from "react-router-dom";
import { auth } from "../../firebase";

export default function Protected({ comp, ...rest }) {
  const [isLoading, setIsLoading] = React.useState(true);

  const history = useHistory();

  React.useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (!user) {
        history.push("/login");
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" h="100vh">
        <Spinner color="blue.400" size="lg" thickness="4px" />
      </Flex>
    );
  } else {
    return (
      <>
        <Route {...rest} component={comp} />
      </>
    );
  }
}
